module.exports = __webpack_public_path__ + "static/media/CashAppBankingHero.409138e6.png";